import { render, staticRenderFns } from "./QualityReviewList.vue?vue&type=template&id=57d17916&"
import script from "./QualityReviewList.vue?vue&type=script&lang=js&"
export * from "./QualityReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports